import { getActiveStore } from 'src/modules/Redux';
import { s3ToCloudFrontURL } from 'src/modules/Utils/helpers';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'src/modules/Redux/store';
import { setShowSettingsModal } from 'src/modules/Redux/slices/settings';

export const NoOrders = () => {
    const dispatch = useAppDispatch();

    const activeStore = useSelector(getActiveStore);

    const _handleClick = () => {
        dispatch(setShowSettingsModal(true));
    };

    return (
        <div
            className="flex flex-col flex-1 items-center justify-center h-full"
            style={{
                fontSize: 'clamp(14px, 3vw, 32px)',
            }}
        >
            {activeStore?.logoUrl && (
                <img
                    className="h-[8em] w-[8em] object-contain rounded-full"
                    src={s3ToCloudFrontURL(activeStore.logoUrl)}
                ></img>
            )}
            <span 
                className="text-[#0F0F0F] pt-[1.5em] font-bold text-[1em] cursor-pointer"
                onClick={_handleClick}
            >
                No orders in queue
            </span>
        </div>
    );
};
